import { isAnimationContent, LinkedContent } from './types';
import { MouseEvent, useContext } from 'react';
import { BookDetailContext } from './components/BookDetailContext';
import { getTrackingURI } from 'app/components/book/BookTrackingWrapper';

export const useLinkedContentLink = (content: LinkedContent, idx?: number): ({
  link: string,
  target?: string,
  onClick?: (event: MouseEvent) => void
})  => {
  const { categoryName } = useContext(BookDetailContext);

  if (isAnimationContent(content)) {
    const utmParams = `?utm_medium=referral&utm_source=ridi&utm_campaign=${encodeURIComponent(categoryName)}`;

    // 라프텔 링크는 유니버설 링크로 제공한다
    const fallbackLink =  `https://laftel.net/item/${content.laftel_id}${utmParams}`;
    const deepLink = `laftel://item/${content.laftel_id}/${utmParams}`;

    // iOS에서는 apple-app-site-association 을 통해서 fallback링크도 딥 링크로 작동
    const needsDeepLink = navigator.userAgent.includes('Android');
    const onClick = needsDeepLink ? (event: MouseEvent) => {
      event.preventDefault();
      location.href = deepLink;
      setTimeout(() => location.href = fallbackLink, 2000);
    } : undefined;

    return { link: fallbackLink, target: '_blank', onClick };
  }

  const uri = getTrackingURI(`/books/${content.book_id}`, {
    sectionId: 'linked_contents',
    sectionItemIdx: idx,
  });

  return { link: uri };
}



// WEBPACK FOOTER //
// ./pages/bookDetail/hooks.ts